import { useState } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { httpClient } from '../../../api/http/http-client';
import BankNote02Icon from '../../../components/Icons/bank-note-02';
import CalendarIcon_2 from '../../../components/Icons/CalendarIcon_2';
import CreditCard01Icon from '../../../components/Icons/credit-card-01';
import ManatIcon from '../../../components/Icons/ManatIcon';
import usePermissions from '../../../store/auth/usePermissions';
import useEmptyStateDialog from '../../../store/ui/useEmptyStateDialog';
import { useCustomNavigate } from '../../../utils/customHooks/useCustomNavigate';
import { GetSalaryCardResponse } from '../model/types';
import SalaryCardItem from './components/SalaryCardItem';
import RestrictionInfoModal from './restriction-info';

const NewApplication = () => {
  const { t } = useTranslation('salary-card');
  const navigate = useCustomNavigate();
  const [openRestrictionInfo, setOpenRestrictionInfo] = useState(false);
  const { permissions } = usePermissions();
  const { open: openEmptyStateDialog } = useEmptyStateDialog();
  const cardDetails = [
    {
      title: t('newApplicationContent.cardDetails.period.title'),
      value: t('newApplicationContent.cardDetails.period.value'),
      icon: <CalendarIcon_2 />,
    },
    {
      title: t('newApplicationContent.cardDetails.currency.title'),
      value: t('newApplicationContent.cardDetails.currency.value'),
      icon: <ManatIcon />,
    },
    {
      title: t('newApplicationContent.cardDetails.type.title'),
      value: t('newApplicationContent.cardDetails.type.value'),
      icon: <CreditCard01Icon />,
    },
    {
      title: t('newApplicationContent.cardDetails.cost.title'),
      value: t('newApplicationContent.cardDetails.cost.value'),
      icon: <BankNote02Icon />,
      isHighlighted: true,
    },
  ];

  const { data } = useQuery({
    queryKey: ['salary-card'],
    queryFn: async (): Promise<GetSalaryCardResponse> =>
      await httpClient.get('/api-web/v1/main/salary_cards'),
  });

  const handleApply = () => {
    if (!permissions['salary-card']?.salary_card) {
      openEmptyStateDialog();

      return;
    }

    if (data?.subscribe === 'Y') {
      navigate(`salary-card/order?type=excel&business_key=${data?.business_key}`);

      return;
    }

    setOpenRestrictionInfo(true);
  };

  return (
    <>
      <SalaryCardItem
        title={t('newApplicationContent.product.title')}
        description={t('newApplicationContent.product.description')}
        applyButtonText={t('newApplicationContent.orderButton')}
        productTypes={cardDetails}
        onApply={handleApply}
      />
      <RestrictionInfoModal open={openRestrictionInfo} setOpen={setOpenRestrictionInfo} />
    </>
  );
};

export default NewApplication;
